var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.269,
    height: 14.269,
    viewBox: "0 0 14.269 14.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-106 -724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(106 724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.485,3.142H1.784a.892.892,0,0,0-.892.892v9.81a.892.892,0,0,0,.892.892h10.7a.892.892,0,0,0,.892-.892V4.034A.892.892,0,0,0,12.485,3.142ZM1.784,2.25A1.784,1.784,0,0,0,0,4.034v9.81a1.784,1.784,0,0,0,1.784,1.784h10.7a1.784,1.784,0,0,0,1.784-1.784V4.034A1.784,1.784,0,0,0,12.485,2.25Z",
    transform: "translate(0 -1.358)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,0a.446.446,0,0,1,.446.446V.892a.446.446,0,0,1-.892,0V.446A.446.446,0,0,1,7.2,0Zm8.026,0a.446.446,0,0,1,.446.446V.892a.446.446,0,1,1-.892,0V.446A.446.446,0,0,1,15.222,0Z",
    transform: "translate(-4.075 0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625,8.321a.446.446,0,0,1,.446-.446h8.918a.446.446,0,0,1,.446.446v.892a.446.446,0,0,1-.446.446H6.071a.446.446,0,0,1-.446-.446Z",
    transform: "translate(-3.395 -4.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2,15.75h.892a.446.446,0,0,1,.446.446v.892a.446.446,0,0,1-.446.446H25.2a.446.446,0,0,1-.446-.446V16.2A.446.446,0,0,1,25.2,15.75Z",
    transform: "translate(-14.94 -9.507)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYear);
export default __webpack_public_path__ + "static/media/year.a951dc1636097d285c0f8f43730e0076.svg";
export { ForwardRef as ReactComponent };